import {BudgetUnassigned} from "@irati/types"
import {IconTooltip} from "@irati/ui/src/Tooltip"
import {Body, H4} from "@irati/ui/src/Typography"
import FormattedMessage, {FormattedNumber} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import React from "react"
import ColorIcon from "../../../components/Budgeting/ColorIcon"
import {Item, Row} from "../EditDashboard/EditableRow"

export function Unassigned({unassigned}: {unassigned: BudgetUnassigned}) {
  return (
    <Row simple>
      <Item area="icon">
        <ColorIcon color={unassigned.metadata.color} size={40} />
      </Item>

      <Item area="name" justifyContent="center">
        <Flex gap={0.5} alignItems="center">
          <Body small>{unassigned.name}</Body>
          <IconTooltip>
            <FormattedMessage id="wallet.reward.budget.dashboard.unassigned.hover" />
          </IconTooltip>
        </Flex>
      </Item>

      <Item area="amount" justifyContent="center" alignItems="flex-end">
        <H4 as="p">
          <FormattedNumber value={unassigned.amount / 100} />
        </H4>
      </Item>
    </Row>
  )
}
